import request from "@/utils/request";

export function getAutoCarAttributeFeeConfig(params){
    return request({
      url:'/jiushi/app/api/carType/enabledList',
      method:"GET",
      params
    })
}
export function apigetDriction(){
    return request({
      url:'/system/app/api/dict/data/type/contraband_type',
      method:'GET',
    })
  }
  /* 获取字典 小蜂蜂发票 */
export function getDictAppInvoice(params){
  return request({
    url:'/system/app/api/dict/data/type/ordinary_user_invoice_rate',
    method:'GET',
  })
}